import { z } from 'zod';

export const IAssetLocation = {
  Domestic: 'Domestic',
  Foreign: 'Foreign',
} as const;

export type IAssetLocation =
  (typeof IAssetLocation)[keyof typeof IAssetLocation];

export const AssetLocationSchema = z.union([
  z.literal(IAssetLocation.Domestic),
  z.literal(IAssetLocation.Foreign),
]);
export type AssetLocation = z.infer<typeof AssetLocationSchema>;
